import axios from 'axios';

export default async function removeSensibleWord({
  accessToken,
  companyId,
  sensibleWord,
  setIsDelete,
}) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    if (setIsDelete) setIsDelete(true);

    const { data } = await axios.post(
      `${process.env.REACT_APP_COMPANIES_API_URL}/remove-sensible-word/${companyId}`,
      { sensible_word: sensibleWord },
      requestOptions,
    );

    return data;
  } catch (err) {
    return err;
  } finally {
    if (setIsDelete) setIsDelete(false);
  }
}
